import React from "react";
import logo from "../assets/images/logo.svg";
import { BsGithub } from "react-icons/bs";
import { FaXTwitter } from "react-icons/fa6";
import { SOCIAL_LINK } from "components/constants";

// Extremely simplified header for single-page landing.
// Click logo to scroll to top.
export default function Header() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header className="bg-white sticky-top">
      <div className="container-lg py-3">
        <div className="d-flex align-items-center">
          <button
            onClick={scrollToTop}
            className="d-flex align-items-center border-0 bg-transparent p-0"
            aria-label="Scroll to top"
          >
            <img src={logo} alt="Grindy Technologies" width="120" />
          </button>

          <div className="ms-auto d-flex align-items-center gap-3">
            <a
              href={SOCIAL_LINK.github}
              target="_blank"
              rel="noopener noreferrer"
              className="text-dark d-flex align-items-center"
              aria-label="GitHub"
            >
              <BsGithub size={22} />
            </a>
            <a
              href={SOCIAL_LINK.x}
              target="_blank"
              rel="noopener noreferrer"
              className="text-dark d-flex align-items-center"
              aria-label="X"
            >
              <FaXTwitter size={22} />
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
